import { render, staticRenderFns } from "./AddGoodsPop.vue?vue&type=template&id=dff5ee98&"
import script from "./AddGoodsPop.vue?vue&type=script&lang=js&"
export * from "./AddGoodsPop.vue?vue&type=script&lang=js&"
import style0 from "./AddGoodsPop.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports